import React, { useState } from 'react';

interface LogoProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const HomeworkGuyLogo: React.FC<LogoProps> = ({ 
  className = '',
  width = 200,
  height = 'auto'
}) => {
  const [useFallback, setUseFallback] = useState(false);
  
  // SVG path with cache busting parameter
  const svgPath = `${process.env.PUBLIC_URL}/images/logoheader.svg?v=${Date.now()}`;
  
  if (useFallback) {
    return (
      <span 
        className="brand-text" 
        style={{ 
          fontFamily: "'Caviar Dreams', sans-serif",
          fontWeight: 'bold',
          fontSize: '1.8rem',
          color: '#ff0000'
        }}
      >
        Homework Guy
      </span>
    );
  }
  
  return (
    <img
      src={svgPath}
      alt="Homework Guy"
      className={`brand-logo ${className}`}
      style={{ 
        width, 
        height,
        imageRendering: '-webkit-optimize-contrast'
      }}
      onError={() => setUseFallback(true)}
    />
  );
};

export default HomeworkGuyLogo; 